import React, { Fragment, useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector, connect } from 'react-redux';
import { Button, Pagination, PaginationItem, PaginationLink, Popover, PopoverBody } from 'reactstrap';
import Input from 'reactstrap/lib/Input';
import Label from 'reactstrap/lib/Label';
import Media from 'reactstrap/lib/Media';

import { size } from 'lodash';
import { getLogRocketUsers, editUserNote } from '../../../actions/admin';
import { UncontrolledPopover } from 'reactstrap/lib';
import moment from 'moment';
import * as constants from '../../../constants/constants';
import closeImg from '../../../images/icons/close.png';

const LogRocket = ({ toggleLogRocket, offset, showNotification, submitUserNote }) => {
  const dispatch = useDispatch();
  const logRocketUsers = useSelector(state => state.admin.logRocketUsers || {});
  const logRocketUsersOrder = useSelector(state => state.admin.logRocketUsersOrder || {});
  const uid = useSelector(state => state.member.uid);

  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [notePopoverOpen, setNotePopoverOpen] = useState(null);
  const [userNote, setUserNote] = useState('');
  const pagesCount = Math.ceil(size(logRocketUsers) / pageSize);

  useEffect(() => {
    if (uid) {
      dispatch(getLogRocketUsers());
    }
  }, [uid]);

  const handleDocumentClick = useCallback((event) => {
    if (notePopoverOpen) {
      if ((!event.target.id || !event.target.id.includes('note-button-')) && !(event.target.className.includes('note-popover-body'))) {
        const justClosedButton = document.getElementById(`note-button-${notePopoverOpen}`);
        if (justClosedButton) justClosedButton.focus();
        setNotePopoverOpen(null);
        setUserNote('');
      }
    }
  }, [notePopoverOpen]);

  useEffect(() => {
    document.addEventListener('click', handleDocumentClick);
    return () => document.removeEventListener('click', handleDocumentClick);
  }, [handleDocumentClick]);

  const toggleUserNoteKey = (key, currentUserNote) => {
    if (!notePopoverOpen || notePopoverOpen !== key) {
      setNotePopoverOpen(key);
      setUserNote(currentUserNote || '');
    } else {
      const justClosedButton = document.getElementById(`note-button-${notePopoverOpen}`);
      if (justClosedButton) justClosedButton.focus();
      setNotePopoverOpen(null);
      setUserNote('');
    }
  };

  const handleUserNote = (e) => {
    setUserNote(e.target.value);
  };

  const saveUserNote = (key, name) => {
    submitUserNote(key, userNote, name).then((res) => {
      if (res.status === constants.SERVER_STATUS_SUCCESS) {
        dispatch(getLogRocketUsers());
        setNotePopoverOpen(null);
        setUserNote('');
        showNotification('Success!', "User's Note has been successfully updated", 'success');
      }
    });
  };

  const changeLogRocket = (uid) => {
    toggleLogRocket(uid);
    dispatch(getLogRocketUsers());
  };

  const handleClick = (e, index) => {
    e.preventDefault();
    setCurrentPage(index);
  };
  return (
    <Fragment>
      <UncontrolledPopover popperClassName={`popover`} placement="right" trigger="focus" target="admin-help-button-logrocket">
        <PopoverBody className="popover-body">
          The list of all players whose sessions are being captured by the LogRocket tool. Here an admin can disable the capturing. Please be aware: the amount of sessions per month is limited, so be mindful and enable this only for a user when it's needed and useful.
        </PopoverBody>
      </UncontrolledPopover>
      <div className="admin-page-content">
        <h2>
          LogRocket Users
          <Button className="admin-help-button" id="admin-help-button-logrocket">
            ?
          </Button>
        </h2>
        <table style={{ width: '100%', fontSize: 12 }}>
          <colgroup>
            <col span="1" className="" />
          </colgroup>
          <thead>
            <tr>
              <th style={{ textAlign: 'center' }}>
                Date
              </th>
              <th style={{ textAlign: 'center' }}>
                Name
              </th>
              <th style={{ textAlign: 'center' }}>
                PlayerId
              </th>
              <th style={{ textAlign: 'center' }}>
                Note
              </th>
              <th style={{ textAlign: 'center' }}>
                LogRocket
              </th>
            </tr>
          </thead>
          <tbody>
            {size(logRocketUsers) > 0 && logRocketUsersOrder.slice(
              currentPage * pageSize,
              (currentPage + 1) * pageSize,
            ).map((key, index) => (
              <Fragment key={logRocketUsers[key].uid}>
                <tr key={logRocketUsers[key].uid} className={`allUsers-table-row ${index % 2 === 0 ? ('odd') : ('even')}`}>
                  <td className="allUsers-table-col">
                    {logRocketUsers[key].enableLogRocketDate
                      ? moment(logRocketUsers[key].enableLogRocketDate + offset).format('DD.MM.YY HH:mm')
                      : '-'
                    }
                  </td>
                  <td className="allUsers-table-col">
                    {logRocketUsers[key].name}
                  </td>
                  <td className="allUsers-table-col">
                    {logRocketUsers[key].uid || key}
                  </td>
                  <td className="allUsers-table-col">
                    <Button id={`note-button-${key}`} type="button" color={logRocketUsers[key]?.userNote ? 'warning' : 'primary'} style={{ fontSize: 10 }} onClick={() => toggleUserNoteKey(key, logRocketUsers[key]?.userNote)}>
                      Show
                    </Button>
                    <Popover isOpen={notePopoverOpen === key} popperClassName={`popover admin-user-note-popover`} placement="top" target={`note-button-${key}`}>
                      <PopoverBody className="popover-body note-popover-body relative">
                        <Media src={closeImg} className="user-note-close-icon" alt="X" onClick={() => toggleUserNoteKey(key)} />
                        <div className="flex flex-column note-popover-body-item">
                          <Label className="note-popover-body-item">Note:</Label>
                          <Input
                            type="textarea"
                            name="userNote"
                            id="userNote"
                            maxLength={500}
                            value={userNote}
                            onChange={handleUserNote}
                            rows={4}
                            className="note-popover-body-item"
                          />
                          <div className="d-flex flex-row items-center justify-center mt-2 note-popover-body-item">
                            <Button className="modal-footer-button mr-1 note-popover-body-item" onClick={() => saveUserNote(key, logRocketUsers[key]?.name || '')}>Save</Button>
                            <Button className="modal-footer-button note-popover-body-item" onClick={() => toggleUserNoteKey(key)}>Close</Button>
                          </div>
                        </div>
                      </PopoverBody>
                    </Popover>
                  </td>
                  <td className="allUsers-table-col">
                    <Button color="warning" onClick={() => { toggleLogRocket(logRocketUsers[key].uid); dispatch(getLogRocketUsers()); }}>
                      Disable LogRocket
                    </Button>
                  </td>
                </tr>
              </Fragment>
            ))}
            {Object.keys(logRocketUsers).length > pageSize && (
              <div className="pagination-wrapper">
                <Pagination aria-label="Page navigation example">

                  <PaginationItem disabled={currentPage === 0}>
                    <PaginationLink onClick={e => handleClick(e, 0)} href="#" style={{ color: '#000' }}>
                      {`‹‹‹`}
                    </PaginationLink>
                  </PaginationItem>

                  <PaginationItem disabled={currentPage <= 0}>
                    <PaginationLink
                      onClick={e => handleClick(e, currentPage - 1)}
                      previous
                      href="#"
                      style={{ color: '#000' }}
                    />
                  </PaginationItem>

                  {[...Array(pagesCount)].map((page, i) => {
                    if (i > currentPage - 3 && i < currentPage + 3) {
                      return (
                        <PaginationItem active={i === currentPage} key={page}>
                          <PaginationLink onClick={e => handleClick(e, i)} href="#" style={i === currentPage ? { color: '#fff' } : { color: '#000' }}>
                            {i + 1}
                          </PaginationLink>
                        </PaginationItem>
                      );
                    }

                    return null;
                  })}

                  <PaginationItem disabled={currentPage >= pagesCount - 1}>
                    <PaginationLink
                      onClick={e => handleClick(e, currentPage + 1)}
                      next
                      href="#"
                      style={{ color: '#000' }}
                    />
                  </PaginationItem>

                  <PaginationItem disabled={currentPage >= pagesCount - 1}>
                      <PaginationLink onClick={e => handleClick(e, pagesCount - 1)} href="#" style={{ color: '#000' }}>
                        {`›››`}
                      </PaginationLink>
                    </PaginationItem>
                </Pagination>
              </div>
            )}
          </tbody>
        </table>
      </div>
    </Fragment>
  );
};

const mapDispatchToProps = {
  submitUserNote: editUserNote,
};

export default connect(null, mapDispatchToProps)(LogRocket);
